import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { isServiceRequestSupportedForMailbox } from 'owa-service/lib/utils/isServiceRequestSupportedForMailbox';
import { isLocalDataBackedMailboxInfo } from 'owa-account-source-list/lib/utils/isLocalDataBackedAccount';
import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 * This capability is being used to determine if mail can be replied or forwarded
 */
export const mailReplyForwardCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return true; // by default
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        // All mailboxes that can make service requests can reply/forward
        return (
            (mailboxInfo && isLocalDataBackedMailboxInfo(mailboxInfo)) ||
            isServiceRequestSupportedForMailbox(mailboxInfo) ||
            isUnifiedInboxMailboxInfo(mailboxInfo)
        );
    },
};
